module.exports = __webpack_public_path__ + "img/ENTJ.567b97b6.png";